import React, { useEffect, useState } from "react";
import RecordedSessions from "../../../Components/CoursesModuleComponents/RecordedSessions";
import LessonsInCourse from "./LessonsInCourse";
import PageTitle from "../../../Components/UI/PageTitle";
import LightButton from "../../../Components/UI/LightButton";
import { useParams } from "react-router-dom";
import { getCourseName } from "../../../apis";

const LessonDetails = () => {
  const { courseId } = useParams();
  const [courseName, setCourseName] = useState("");
  useEffect(() => {
    getCourseName(courseId).then((response) => {
      setCourseName(response.data.name);
    });
  }, [courseId]);

  return (
    <>
      <PageTitle
        BreadcrumbItems={[
          { title: "Home", link: "/" },
          {
            title: "Courses Management",
            link: `/courses-management`,
          },
          { title: "Course Details", link: `/courses-management/${courseId}` },
          { title: "Lessons List" },
        ]}
      />

      <div className="tw-flex max-lg:tw-flex-col max-lg:tw-gap-4 justify-content-between tw-items-center tw-mb-6">
        <h2 className="h4 !tw-m-0">
          Lessons Of <span className="tw-text-primary">{courseName || ""}</span>{" "}
          Course
        </h2>
        <LightButton
          hoverColor={"hover:!tw-text-blueLight"}
          text={"Add New Lesson"}
          icon={<span className="material-icons tw-me-1">add</span>}
          to={"add-new-lesson"}
        />
      </div>
      <div className="tw-flex tw-flex-col tw-gap-4">
        <LessonsInCourse />
        <RecordedSessions title={"Recorded Sessions"} />
      </div>
    </>
  );
};

export default LessonDetails;
